export default __webpack_public_path__ + "static/media/Offline.edbd7303.svg";